import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { renderToStaticMarkup } from 'react-dom/server';
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,CCol,
	CContainer,
	CForm,CFormInput,CFormTextarea,CInputGroup,CInputGroupText,
		CFormCheck,CButton,CFormSelect,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CNav, CNavItem, CNavLink, CTabContent, CTabPane,
	CImage,
	CLink,
	CTooltip,
	CSpinner, CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import SignatureCanvas from 'react-signature-canvas';
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyButton,
	MyDialogform,
	MyDialogformFs,
	MySessionextender,
	MyDialoglookupconsent,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'
import { renderSignature } from '../../helpers/imageUtils'; // <--- This is the import

const pjson 		= require('../../../package.json')
const Consentform2 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	const uRefcanvas 			= React.useRef({});
	const uRefparentcanvas 		= React.useRef(null);
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);
	const uSystemconfigObj			= useSelector(state => state.gCabangatribut) || {};

	const uDataconsentObj			= useSelector(state => state.gConsentcreateObj) || {};

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 

	const uDokterID 				= parseInt(uDataconsentObj.id_dokter)||0;
	const uPasienID 				= parseInt(uDataconsentObj.id_pasien)||0;
	const uJenisconsentID			= parseInt(uDataconsentObj.jenis_id)||0;
	const uCabangID					= parseInt(uDataconsentObj.id_cabang) || parseInt(uTokenObj.user_cabangid);
	const uURLdone					= uDataconsentObj.url_done;

	const [uDatakuasaArr,setDatakuasaArr]	= React.useState([])
	const [uDatadokterObj,setDatadokterObj]	= React.useState({})
	const [uDatapasienObj,setDatapasienObj]	= React.useState({})
	const [uDatamainObj,setDatamainObj]	= React.useState({})
	const [uDatadefaultObj,setDatadefaultObj]	= React.useState({})
	const [activeKey,setActiveKey]		= React.useState(1);
	const [uISFieldupdated,setFieldupdated]	= React.useState(false);
	const uFrameExport 				= document.getElementById("ifmcontentstoprint");

	const uVariabelinputArr		= [
		{nama_vars:"_ISIAN1_",label:"Manfaat Tindakan",content:null},
		{nama_vars:"_ISIAN2_",label:"Tindakan Alternatif",content:null},
		{nama_vars:"_ISIAN3_",label:"Risiko Lainnya",content:null},
		{nama_vars:"_ISIAN4_",label:"Alasan Lain Pemberian Kuasa",content:null},
	];
	const uHTMLeditable				= 
		"<small class='text-muted fst-italic d-inline-block mx-2 mx-lg-5'>"+
		"&middot;&middot;"+(isMobile?"Tap":"Klik")+" Untuk Edit&middot;&middot;"+
		"</small>";

	const uHTMLcontentmainArr			= [`
		<ol style="padding:0 5mm 0 8mm;">
		<li><p><b>PEMBERIAN INFORMASI</b></p>
			<ol style="padding:0;list-style-type:none;">
				<li style="display:flex;margin-bottom:2mm">
				<span style="width:auto; flex-shrink: 0;">1.1.</span>
				<span>Yang bertanda tangan di bawah ini telah mendapatkan informasi tentang operasi / tindakan: <b>_NAMATINDAKAN_</b>

					<p>Yang dilaksanakan oleh dokter: <b>_NAMADOKTER_</b>.</p>

					<p>Diagnosis, indikasi, tata cara, tujuan, alternative tindakan, 
					risiko, komplikasi yang mungkin dapat terjadi dari tindakan tersebut 
					dan prognosis terhadap tindakan telah dijelaskan kepada saya oleh dokter tersebut diatas.</p>

					Saya juga telah dijelaskan mengenai:
					<ul>
						<li>Manfaat dari tindakan yang dilakukan, seperti:
							<div>_ISIAN1_</div>
						</li>
						<li>Pilihan tindakan alternatif, seperti:
							<div>_ISIAN2_</div>
						</li>
					</ul>
				</span>
				</li>

				<li style="display:flex;margin-bottom:2mm">
				<span style="flex-shrink: 0;">1.2.</span>
				<span>Yang bertanda tangan di bawah ini juga menyatakan telah mendapat informasi tentang:
					<ul>
					<li>Transfusi darah dan produk-produk lain dari darah, bila dirasa perlu oleh dokter.</li>
					<li>Ahli bedah yang bertugas mencari konsultasi atau mendapat bantuan dari dokter lain yang berkaitan jika dirasakan perlu, selama pelaksanaan tindakan atau operasi berlangsung.</li>
					<li>Pasien dapat dirawat di ruang intensif setelah operaasi sesuai kondisi pasien, perawatan intensif dan tindakan medis yang lazimnya dilakukan di perawat intensif.</li>
					<li>Bila perawat kamar bedah mengalami luka tusuk / terpapar cairan tubuh pasien, pasien setuju untuk diperiksa darahnya</li>
					</ul>
				</span>
				</li>

				<li style="display:flex;margin-bottom:2mm;">
				<span style="flex-shrink: 0;">1.3.</span>
				<span>RISIKO DARI TINDAKAN YANG AKAN DILAKSANAKAN
					<p>Risiko yang dapat terjadi antara lain: reaksi alergi, pendarahan, pembekuan darah, infeksi, efek samping dari penggunaan obat-obat, atau bahkan hilangnya sebagian dari fungsi tubuh dan kematian.</p>
					<div>Risiko lainnya yang dapat terjadi: _ISIAN3_</div>
				</span>
				</li>
			</ol>
		</li>
		</ol>
		`,`
		<ol start="2" style="padding:0 5mm 0 8mm;">
		<li><p><b>PERSETUJUAN TINDAKAN MEDIK / BEDAH</b></p>
			<ol style="padding:0;list-style-type:none;">
				<li style="display:flex;margin-bottom:2mm">
					<span style="flex-shrink: 0;">2.1.</span>
					<span>Saya memahami dan mengerti dengan jelas mengenai informasi dan penjelasan tindakan yang disampaikan.
					</span>
				</li>

				<li style="display:flex;margin-bottom:2mm">
					<span style="flex-shrink: 0;">2.2.</span>
					<span>Saya menyadari sepenuhnya bahwa pada tindakan medis, 
						berbagai risiko dan komplikasi yang tidak didiskusikan sebelumnya 
						mungkin dapat timbul. Saya juga menyadari bahwa selama berlangsungnya 
						tindakan tersebut ada kemungkinan timbul kondisi-kondisi yang tidak terduga 
						dimana hal tersebut memerlukan tindakan-tindakan perluasan operasi 
						yang berhubungan dengan operasi yang sedang dilakukan, 
						untuk itu saya menyetujui dilakukannya tindakan tersebut apabila diperlukan. 
						Selanjutnya saya menyadari bahwa tidak ada jaminan atau janji-janji yang 
						diberikan kepada saya sehubungan dengan hasil dari segala tindakan dan atau perawatan.
					</span>
				</li>

				<li style="display:flex;margin-bottom:2mm">
					<span style="flex-shrink: 0;">2.3.</span>
					<span>Saya menyetujui pelaksanaan dari tindakan yang dijelaskan di atas.</span>
				</li>
			</ol>
		</li>
		</ol>
	`];
	const uHTMLpersetujuan			=
		"<p>Bila pasien berusia di bawah usia 21 tahun atau tidak dapat memberikan persetujuan karena alasan lain (*) tidak dapat menandatangani surat diatas, pihak OMNI Dental Clinic dapat mengambil kebijaksanaan dengan memperoleh tandatangan dari orang tua, pasangan, anggota keluarga terdekat atau wali dari pasien.</p>"+
		"<p>(*) Jelaskan alasan lainnya: _ISIAN4_</p>"+
		"<p>Saya <b>_JENISKUASA_</b> dari pasien <b>_NAMAPASIEN_</b>:</p>"+
		"<ul>"+
			"<li>Membenarkan bahwa saya memiliki hak untuk menandatangani form consent atas nama pasien.</li>"+
			"<li>Telah membaca, memahami & menerima semua informasi pada form persetujuan ini.</li>"+
			"<li>Memastikan bahwa saya telah diberi penjelasan dan mengerti dengan baik tentang tindakan tersebut</li>"+
		"</ul>"+
	"";
	const uDefaultvarObj 			= {
		id_jenis_consent: uJenisconsentID,
		titel_jenis_consent: "PEMBERIAN INFORMASI & PERSETUJUAN TINDAKAN MEDIK / BEDAH",
		id_cabang: uCabangID,
		tgl_consent: UFunc.DbDatetime(),
		kuasa_id: 1, 
		variabelarrdefault: uVariabelinputArr,
	}
	const uHTMLIdentitasklinik	= `
		<table class="classtabelhtml">
		<tbody>
			<tr valign="middle"> 
				<td align="right" style="font-size:smaller;padding:0;">_TELPHP_</td>
				<td align="center" width="5%" style="padding:0">&phone;</td> 
			</tr> 
			<tr valign="middle"> 
				<td align="right" style="font-size:smaller;padding:0.5mm;">_EMAIL_</td>
				<td align="center" style="padding:0.5mm">&commat;</td> 
			</tr> 
			<tr valign="top">
				<td align="right" style="font-size:smaller;padding:0;">_ALAMATKLINIK_</td>
				<td align="center" style="padding:0">&#128205;</td> 
			</tr> 
		</tbody> 
		</table> 
	`;

	//--DLG_FORM--/
	const [uDlgformObj,setDlgformObj]		= React.useState({})
	const [uISDlgformshow,setDlgformshow]	= React.useState(false)
	const [uISDlgformFsshow,setDlgformFsshow]= React.useState(false)
	//--END DLG_FORM--/

	//--DLG_LOOKUPCONSENT--/
	const [uDlglookupconsentObj,setDlglookupconsentObj]		= React.useState({})
	const [uISDlglookupconsentshow,setDlglookupconsentshow]	= React.useState(false)
	//--END DLG_LOOKUPCONSENT--/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {
		if(_EV.keyCode===120) {
			document.getElementById("btnSimpanmain") &&
				document.getElementById("btnSimpanmain").click();
			return;
		}
	}
	const hdlKlikBack = async() => {
		if(uISFieldupdated) {
			if(await Konfirm("<div><b>Anda Akan Meninggalkan FORM Consent</b>..</div>"+
				"<p class='fst-italic mx-3'>Beberapa Data Telah Mengalami Perubahan, dan Tidak Dapat dikembalikan.</p>"+
				"<p>Apakah Anda Yakin Akan Melanjutkan ?</p>"+
				"")) {
				uNavigate(-1); 
			} 
			return;
		}

		uNavigate(-1); 
	}
	const hdlKlikReset = async() => {
		if(uHtml500msg || !uISFieldupdated) {
			setDatadefaultObj({...uDefaultvarObj});
			apiLoadawal(); 
			return;
		}

		if(await Konfirm("<div><b>Informed Consent Akan DIRESET</b>..</div>"+
			"<p class='fst-italic mx-3'>Beberapa Data Telah Mengalami Perubahan, dan Tidak Dapat dikembalikan.</p>"+
			"<p>Apakah Anda Yakin Akan Melanjutkan ?</p>"+
			"")) {
			setDatamainObj({...uDatadefaultObj,
				variabelarr: [...(uDatadefaultObj.variabelarrdefault||[])],
				variabelarrdefault:undefined,
			});
		}
	}
	const hdlKlikEditconsent = (_FIELDNAME,_IDX) => {
		_FIELDNAME 	= _FIELDNAME || "undf";
		_IDX		= parseInt(_IDX);

		let vHeaders;
		let vDlginput = "ONE";
		let vAddedObj = {};
		let vElfocus;
		if(_FIELDNAME === "nama_tindakan") {
			prosesLoadtindakan(); return;

			/*//--TIDAK_DIPAKAI--/
			vHeaders = "Nama Tindakan";
			vAddedObj[_FIELDNAME] = uDatamainObj[_FIELDNAME] || "";
			//--END LAMA--*/
		} else if(_FIELDNAME === "kuasa_id") {
			vHeaders 	= "Wali (Kuasa) Pasien";
			vDlginput 	= _FIELDNAME;
			vAddedObj	= {...(uDatamainObj.kuasa_obj || {}),
				kuasa_id: uDatamainObj.kuasa_id,
			}
		} else if(_FIELDNAME === "id_pasien") {
			vHeaders 	= "Data Pasien";
			vDlginput 	= _FIELDNAME;
			vAddedObj	= {...(uDatamainObj.pasien_obj || {}),
				id_pasien: uDatamainObj.id_pasien,
			}
		}else if(_FIELDNAME === "variabelarr") {
			vHeaders 	= ((uDatamainObj.variabelarr||[])[_IDX]||{}).label || "Undf";
			vDlginput 	= "textarea";
			vAddedObj.isi_textarea = ((uDatamainObj.variabelarr||[])[_IDX]||{}).content||"";			
		}else if(_FIELDNAME === "dokter_obj") {
			vHeaders 	= "Dokter Pelaksana";
			vDlginput 	= "signature";
			vAddedObj	= {...(uDatamainObj.dokter_obj || {})}
		}else if(_FIELDNAME === "kuasa_obj") {
			vHeaders 	= "Penerima Informasi (Wali)";
			vDlginput 	= "signature";
			vAddedObj	= {...(uDatamainObj.kuasa_obj || {})}
		}else if(_FIELDNAME === "saksikeluarga_obj") {
			vHeaders 	= "Saksi Keluarga";
			vDlginput 	= "signature";
			vAddedObj	= {...(uDatamainObj.saksikeluarga_obj || {})}
		}else if(_FIELDNAME === "saksiklinik_obj") {
			vHeaders 	= "Saksi Klinik";
			vDlginput 	= "signature";
			vAddedObj	= {...(uDatamainObj.saksiklinik_obj || {})}
		}

		setDlgformObj({
			dlg_header: vHeaders,
			dlg_jenis: _FIELDNAME,
			dlg_input: vDlginput,
			dlg_indeks: _IDX,
			...vAddedObj,
		})

		if(!isMobile) {
			setDlgformshow(true);
		
			let vTimeout = setTimeout(() => {
				clearTimeout(vTimeout);
				vElfocus 	= document.getElementById("inpforminputteks");
				vElfocus && vElfocus.focus();
			}, 350);
		} else setDlgformFsshow(true);
	}
	const hdlKlikEditsignature = (_FIELDNAME) => { hdlKlikEditconsent(_FIELDNAME); }
	const hdlKlikDlgformsimpan = () => {
		//--VALIDASI--/
		let vElfocus	= document.getElementById("inpforminputteks");
		if(uDlgformObj.dlg_jenis === "nama_tindakan") {
			if((uDlgformObj.nama_tindakan||"").trim() === "") {
				vElfocus && vElfocus.focus();
				showToast("Nama Tindakan Harus Diisi !"); return;
			}
			prosesNamatindakan();
		} else if(uDlgformObj.dlg_jenis === "id_pasien") {
			vElfocus	= document.getElementById("inpformpasienumur");
			if((parseInt(uDlgformObj.umur)||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Umur Harus Diisi !"); return;
			}
			vElfocus	= document.getElementById("inpformpasienalamat");
			if((uDlgformObj.alamat||"").trim() === "") {
				vElfocus && vElfocus.focus();
				showToast("Alamat Harus Diisi !"); return;
			}

			prosesPasiendata();
		} else if(uDlgformObj.dlg_jenis === "kuasa_id") {
			if((parseInt(uDlgformObj.kuasa_id)||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Jenis Wali (Kuasa) Harus Dipilih !"); return;
			}

			if((parseInt(uDlgformObj.kuasa_id)||0) > 1) {
				if((parseInt(uDlgformObj.kuasa_id)||0) === 6) {
					if((uDlgformObj.kuasa_lainnya||"").trim() === "") {
						vElfocus && vElfocus.focus();
						showToast("Jenis Wali (Kuasa) Lainnya Harus Diisi !"); return;
					}
				}
				vElfocus	= document.getElementById("inpkuasanama");
				if((uDlgformObj.label_nama||"").trim() === "") {
					vElfocus && vElfocus.focus();
					showToast("Nama Wali (Kuasa) Harus Diisi !"); return;
				}
				if((uDlgformObj.label_nama||"").trim().toUpperCase() === 
					(uDatamainObj.nama_pasien||"").trim().toUpperCase()
					) {
					vElfocus && vElfocus.focus();
					showToast("Nama Wali dan Nama Pasien Tidak Boleh Sama !"); return;
				}
				vElfocus	= document.getElementById("inpkuasaumur");
				if((parseInt(uDlgformObj.umur)||0) <= 0) {
					vElfocus && vElfocus.focus();
					showToast("Umur Harus Diisi !"); return;
				}
				vElfocus	= document.getElementById("inpkuasaalamat");
				if((uDlgformObj.alamat||"").trim() === "") {
					vElfocus && vElfocus.focus();
					showToast("Alamat Harus Diisi !"); return;
				}
			}
			prosesKuasaid();
		} else if(uDlgformObj.dlg_jenis === "variabelarr") {
			prosesVariabelarr();
		} else if(uDlgformObj.dlg_jenis === "saksikeluarga_obj") {
			const strokes = uRefcanvas.current?.toData?.() || [];
			if((uDlgformObj.label_nama||"").trim() === "" && strokes.length > 0) {
				vElfocus && vElfocus.focus();
				showToast("Nama Saksi Keluarga Harus Diisi !"); return;
			}
			
			if (strokes.length <= 0 && (uDlgformObj.label_nama||"").trim() !== "") {
				vElfocus && vElfocus.focus();
				showToast("Tanda Tangan Saksi Keluarga Harus Dilakukan !"); return;
			} 
			prosesSaksikeluargaobj();
		} else if(uDlgformObj.dlg_jenis === "saksiklinik_obj") {
			const strokes = uRefcanvas.current?.toData?.() || [];
			if((uDlgformObj.label_nama||"").trim() === "") {
				vElfocus && vElfocus.focus();
				showToast("Nama Saksi Klinik Harus Diisi !"); return;
			} 
			
			if (strokes.length <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Tanda Tangan Saksi Klinik Harus Dilakukan !"); return;
			} 
			prosesSaksiklinikobj();
		} else if(uDlgformObj.dlg_jenis === "dokter_obj") {
			prosesDokterobj();
		} else if(uDlgformObj.dlg_jenis === "kuasa_obj") {
			prosesKuasaobj();
		}
		//--END VALIDASI--/

		if(isMobile) setDlgformFsshow(false);
		else setDlgformshow(false);
	}
	const hdlKlikPreview = async() => {
		const vDokterObj = uDatamainObj.dokter_obj || {};
		const vKuasaObj 		= uDatamainObj.kuasa_obj || {};
		const vPasienObj 		= uDatamainObj.pasien_obj || {};

		//--VALIDASI--//
		if((uDatamainObj.nama_tindakan||"").trim() === "") {
			showToast("Nama Tindakan Harus Diisi !"); return;
		}
		if((parseInt(vPasienObj.umur)||0) <= 0) {
			showToast("Umur Pasien Harus Diisi !"); return;
		}
		if((parseInt(vKuasaObj.umur)||0) <= 0) {
			showToast("Umur Penerima Informasi (Wali) Harus Diisi !"); return;
		}
		/*if((vDokterObj.url_tandatangan||"") === "") {
			showToast("Pemberi Informasi Belum Memberikan TANDA TANGAN !"); return;
		}
		if((vKuasaObj.url_tandatangan||"") === "") {
			showToast("Penerima Informasi (Wali) Belum Memberikan TANDA TANGAN !"); return;
		}//-*/
		//--END VALIDASI--//*/

		//--CREATE_HTML--/
		let vContent 	= contentHTMLcetak();

		//--HANYA_UTK_PREVIEW--/
		const vSaksiklinikObj	= uDatamainObj.saksiklinik_obj || {};
		const vSaksikeluargaObj	= uDatamainObj.saksikeluarga_obj || {};

		const vImgkuasa			= "<br/><br/>ttd.<br/><br/>";
		const vImgdokter		= "<br/><br/>ttd.<br/><br/>";
		const vImgsaksiklinik	= "<br/><br/>ttd.<br/><br/>";
		const vImgsaksikeluarga	= "<br/><br/>ttd.<br/><br/>";
		const vImglogo			= "";
		const vIdentitasklinik	= "";
		//-*/

		/*const vImglogo	= "<img src='"+(pjson.homepage+"api/images/logo_default.png")+"' style='width:40mm;'/>";
		const vIdentitasklinik	=
			"<div>Telp."+(uSystemconfigObj.telp_hp||"0812-1515-6161")+" &phone;</div>"+
			"<div>"+(uSystemconfigObj.email||"omniklinikgigi@gmail.com")+" &commat;</div>"+
			"<div>"+(UFunc.br2nl(uSystemconfigObj.alamat_klinik||"Palembang - Sumatera Selatan"))+" &#128205;</div>"+
			"";
		const vImgkuasa	= vKuasaObj.url_tandatangan
			? "<img src='"+vKuasaObj.url_tandatangan+"' style='width:50mm'/>" : "<br/><br/>ttd.<br/>";
		const vImgpemberiinfo	= vDokterObj.url_tandatangan
			? "<img src='"+vDokterObj.url_tandatangan+"' style='width:50mm'/>" : "<br/>ttd.<br/>";
		const vImgsaksiklinik	= vSaksiklinikObj.url_tandatangan
			? "<img src='"+vSaksiklinikObj.url_tandatangan+"' style='width:50mm'/>" : "<br/><br/>ttd.<br/>";
		const vImgsaksikeluarga	= vSaksikeluargaObj.url_tandatangan
			? "<img src='"+vSaksikeluargaObj.url_tandatangan+"' style='width:50mm'/>" : "<br/><br/>ttd.<br/>";
		//-IMG_CACHE--/
		const img = new Image();
		img.src = pjson.homepage+"api/images/logo_default.png";
		await img.decode(); 
		//-END IMG_CACHE--/
		//-*/

		vContent	= vContent.replace(new RegExp("_LOGO_","ig"),vImglogo);
		vContent	= vContent.replace(new RegExp("_IDENTITASKLINIK_","ig"),vIdentitasklinik);
		vContent	= vContent.replace(new RegExp("_NAMAKOTA_","ig"),"Palembang");
		vContent	= vContent.replace(new RegExp("_TTDKUASA_","ig"),vImgkuasa);
		vContent	= vContent.replace(new RegExp("_TTDDOKTER_","ig"),vImgdokter);
		vContent	= vContent.replace(new RegExp("_TTDSAKSIKELUARGA_","ig"),vImgsaksikeluarga);
		vContent	= vContent.replace(new RegExp("_TTDSAKSIKLINIK_","ig"),vImgsaksiklinik);
		//--END HANYA_UTK_PREVIEW--/
		//--END CREATE_HTML--/

		uFrameExport.srcdoc = vContent;
		uFrameExport.onload = function() {
			uFrameExport.contentWindow.focus();
			uFrameExport.contentWindow.print();
		};
	}
	const hdlKlikDlglookupconsentpilih = (_OBJITEM) => {
		_OBJITEM = _OBJITEM||{};
		if(!(_OBJITEM.id) || (parseInt(_OBJITEM.id)||0) <= 0) {
			setDlgformObj({
				dlg_header: "Nama Tindakan",
				dlg_jenis: "nama_tindakan",
				dlg_input: "ONE",
				dlg_indeks: -1,
				nama_tindakan: _OBJITEM.caption,
				id_tindakan: parseInt(_OBJITEM.id)||0,
			})

			if(!isMobile) {
				setDlgformshow(true);

				let vTimeout = setTimeout(() => {
					clearTimeout(vTimeout);
					const vElfocus 	= document.getElementById("inpforminputteks");
					vElfocus && vElfocus.focus();
				}, 350);
			} else setDlgformFsshow(true);
			return;
		}

		apiLoadtindakan(_OBJITEM);
	}

	const hdlKlikSimpanmain = async() => {
		const vDokterObj = uDatamainObj.dokter_obj || {};
		const vKuasaObj 		= uDatamainObj.kuasa_obj || {};
		const vPasienObj 		= uDatamainObj.pasien_obj || {};

		//--VALIDASI--//
		if((uDatamainObj.nama_tindakan||"").trim() === "") {
			showToast("Nama Tindakan Harus Diisi !"); return;
		}
		if((vDokterObj.url_tandatangan||"") === "") {
			showToast("Dokter Belum Memberikan TANDA TANGAN !"); return;
		}
		if((vKuasaObj.url_tandatangan||"") === "") {
			showToast("Penerima Informasi (Wali) Belum Memberikan TANDA TANGAN !"); return;
		}
		if((parseInt(vPasienObj.umur)||0) <= 0) {
			showToast("Umur Pasien Harus Diisi !"); return;
		}
		if((parseInt(vKuasaObj.umur)||0) <= 0) {
			showToast("Umur Penerima informasi (Wali) Harus Diisi !"); return;
		}
		//--END VALIDASI--//*/

		//--KIRIM_API--/
		if(await Konfirm(
			"<p><b>Data Informed Consent Akan Disimpan</b>..</p>"+
			"<p class='mx-3'><small>Pastikan Data Yang Diinput Sudah Benar, Karena tidak dapat DIBATALKAN dan DIULANGI..</small></p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) apiProsessimpan();
		//--END KIRIM_API--/
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	const prosesLoadtindakan = () => {
		setDlglookupconsentObj({
			dlg_header:"Lookup: Tindakan Informed Consent",
			dlg_urltarget: pjson.homepage+"api/api_consent/ld_tindakan/",
		})
		setDlglookupconsentshow(true);
	}
	const initResizecanvas = () => {
		const canvas 	= uRefcanvas && uRefcanvas.current.getCanvas();
		const container = uRefparentcanvas && uRefparentcanvas.current;

		if (canvas && container) {
			const tempImage = uRefcanvas.current.toDataURL();

			canvas.width 	= container.offsetWidth;
			canvas.height 	= container.offsetHeight;

			uRefcanvas.current.fromDataURL(tempImage);
		}
	}

	const prosesNamatindakan = () => {
		const vContentArr = JSON.parse(uDlgformObj.content_str || "[]");

		setDatamainObj({...uDatamainObj,
			id_tindakan: parseInt(uDlgformObj.id_tindakan)||0,
			nama_tindakan: (uDlgformObj.nama_tindakan||"").trim(),
			variabelarr: (uDatamainObj.variabelarr||[]).map(vItems=>{
				const vArridx = UFunc.getObjectIndeks(vContentArr, vItems.nama_vars,"nama_vars");

				return {...vItems,
					content: (vContentArr[vArridx]||{}).content,
				}
			}),
		});
	}
	const prosesPasiendata = () => {
		const vKuasaid		= parseInt(uDatamainObj.kuasa_id)||0;
		const vPasiennama	= (uDlgformObj.label_nama||"").trim();

		const vPasienObj	= {
			label_nama: (uDlgformObj.label_nama||"").trim(),
			sex_label: (uDlgformObj.sex_label||"").trim(),
			umur: parseInt(uDlgformObj.umur)||0,
			nik: (uDlgformObj.nik||"").trim(),
			alamat: (uDlgformObj.alamat||"").trim(),
		}

		let vKuasaObj = {}
		if(vKuasaid === 1) 
			vKuasaObj = {
				umur: parseInt(uDlgformObj.umur)||0,
				nik: (uDlgformObj.nik||"").trim(),
				alamat: (uDlgformObj.alamat||"").trim(),
			}

		setDatamainObj({...uDatamainObj,
			nama_pasien: vPasiennama,
			pasien_obj: {...(uDatamainObj.pasien_obj||{}),...vPasienObj },
			kuasa_obj: {...(uDatamainObj.kuasa_obj||{}),...vKuasaObj },
		});
	}
	const prosesKuasaid = () => {
		const vKuasaid		= parseInt(uDlgformObj.kuasa_id)||0;
		let vKuasasebagai	= (uDlgformObj.kuasa_lainnya||"").trim();
		let vKuasanama		= (uDlgformObj.label_nama||"").trim();
		if(vKuasaid !== 6 ) {
			const vArridx 	= UFunc.getObjectIndeks(uDatakuasaArr,vKuasaid);
			vKuasasebagai	= (uDatakuasaArr[vArridx]||{}).nama_kuasa||"";
		}

		let vTmpObj	= {
			kuasa_sebagai : vKuasasebagai,
			label_nama: (uDlgformObj.label_nama||"").trim(),
			sex_label: (uDlgformObj.sex_label||"").trim(),
			umur: parseInt(uDlgformObj.umur)||0,
			nik: (uDlgformObj.nik||"").trim(),
			alamat: (uDlgformObj.alamat||"").trim(),
		}

		if(vKuasaid === 1 ) {
			const vPasienObj 	= uDatamainObj.pasien_obj || {};
			vKuasanama			= (vPasienObj.label_nama||"").trim();

			vTmpObj = {...vTmpObj,
				label_nama: (vPasienObj.label_nama||"").trim(),
				sex_label: (vPasienObj.sex_label||"").trim(),
				umur: parseInt(vPasienObj.umur)||0,
				nik: (vPasienObj.nik||"").trim(),
				alamat: (vPasienObj.alamat||"").trim(),
			}
		}

		setDatamainObj({...uDatamainObj,
			kuasa_id: vKuasaid,
			nama_kuasa: vKuasanama,
			kuasa_obj: {...(uDatamainObj.kuasa_obj||{}),...vTmpObj }
		});
	}
	const prosesVariabelarr = () => {
		const vArridx		= parseInt(uDlgformObj.dlg_indeks);
		const vVariabelObj 	= (uDatamainObj.variabelarr||[])[vArridx]||{};

		(uDatamainObj.variabelarr||[])[vArridx] = {
			...vVariabelObj,
			content: (uDlgformObj.isi_textarea||"").trim(),
		};

		setDatamainObj({...uDatamainObj,
			variabelarr: [...(uDatamainObj.variabelarr||[])]
		});
	}
	const prosesSaksikeluargaobj = () => {
		/*let vDataurl;
		const strokes = uRefcanvas.current?.toData?.() || [];
		if (strokes.length > 0) {
			vDataurl = uRefcanvas.current.getCanvas().toDataURL('image/png');
		}//-*/
		const canvas 	= uRefcanvas.current.getCanvas();
		const vDataurl 	= renderSignature(canvas,225);

		setDatamainObj({...uDatamainObj,
			saksikeluarga_obj: {
				...(uDatamainObj.saksikeluarga_obj||{}),
				url_tandatangan: vDataurl,
				label_nama: (uDlgformObj.label_nama||"").trim()
			},
		});
	}
	const prosesSaksiklinikobj = () => {
		const canvas 	= uRefcanvas.current.getCanvas();
		const vDataurl 	= renderSignature(canvas,225);
		
		setDatamainObj({...uDatamainObj,
			saksiklinik_obj: {
				...(uDatamainObj.saksiklinik_obj||{}),
				url_tandatangan: vDataurl,
				label_nama: (uDlgformObj.label_nama||"").trim()
			},
		});
	}
	const prosesDokterobj = () => {
		const canvas 	= uRefcanvas.current.getCanvas();
		const vDataurl 	= renderSignature(canvas,225);
		
		setDatamainObj({...uDatamainObj,
			dokter_obj: {
				...(uDatamainObj.dokter_obj||{}),
				url_tandatangan: vDataurl,
			},
		});
	}
	const prosesKuasaobj = () => {
		const canvas 	= uRefcanvas.current.getCanvas();
		const vDataurl 	= renderSignature(canvas,225);

		setDatamainObj({...uDatamainObj,
			kuasa_obj: {
				...(uDatamainObj.kuasa_obj||{}),
				url_tandatangan: vDataurl,
			},
		});
	}
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentHeadersub = () => {
		if(uHtml500msg) return (
		<>
		Page 500
		<CLink onClick={()=>hdlKlikReset()} className="classcursorpointer classikon classikonreset"/>
		</>
		)//>

		return (
		<>
		<b className="text-info d-none d-md-block">PEMBERIAN INFORMASI & PERSETUJUAN TINDAKAN MEDIK / BEDAH</b>
		<b className="text-info d-md-none">
			<small>INFORMASI & PERSETUJUAN TINDAKAN</small>
		</b>
		
		<CTooltip content="--Reset Form Consent">
		<CLink onClick={()=>hdlKlikReset()} className="classcursorpointer classikon classikonreset"/>
		</CTooltip>
		</>
		)//>
	}
	const contentConsentdata = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="h-100 classbgcard">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>1. Data Consent</small>
		</CCardHeader>

		<CCardBody className="">
			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Tgl Consent</small></CCol>
			<CCol className="text-primary text-end text-md-start">{UFunc.WaktuAngka()}</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Dokter<span className="ms-1 d-none d-md-inline">Pelaksana Tindakan</span></small></CCol>
			<CCol className="text-primary text-end text-md-start">
				{uDatamainObj.nama_dokter||"Undf Dokter"}
			</CCol>
			</CRow>

			{(1===3) && (
			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Petugas<span className="ms-1 d-none d-md-inline">Pemberi Informasi</span></small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<div onClick={()=>hdlKlikEditconsent("pemberi_informasi")} className="classconsentklikedit d-lg-inline-block">
				{UFunc.renderHTML(uDatamainObj.pemberi_informasi || uHTMLeditable)}
				</div>
			</CCol>
			</CRow>
			)}

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small><span className="me-1 d-none d-md-inline">Nama</span>Tindakan</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<div onClick={()=>hdlKlikEditconsent("nama_tindakan")} className="classconsentklikedit d-lg-inline-block text-capitalize">
				{UFunc.renderHTML(uDatamainObj.nama_tindakan || uHTMLeditable)}
				</div>
			</CCol>
			</CRow>
		</CCardBody>
		</CCard>
		)//>
	}
	const contentPasien = () => {
		if(uHtml500msg) return "";

		const vDatapasienObj	= uDatamainObj.pasien_obj || {};

		return (
		<CCard className="h-100 classbgcard">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>2. Data Pasien</small>
		</CCardHeader>

		<CCardBody className="">
			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Nama Pasien</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<div onClick={()=>hdlKlikEditconsent("id_pasien")} className="classconsentklikedit d-lg-inline-block" >
				{uDatamainObj.nama_pasien || "Undf Pasien"}
				</div>
			</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Umur / Sex</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				{vDatapasienObj.umur|| "UNDF"} th
				<span> &middot; </span>
				<b>{vDatapasienObj.sex_label|| "Laki-laki"}</b>
			</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Alamat</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<i>{UFunc.renderHTML(vDatapasienObj.alamat || "-")}</i>
			</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>NIK</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<b>{vDatapasienObj.nik|| "-"}</b>
			</CCol>
			</CRow>
		</CCardBody>
		</CCard>
		)//>
	}
	const contentKuasa = () => {
		if(uHtml500msg) return "";

		const vKuasaObj	= uDatamainObj.kuasa_obj || {};

		return (
		<CCard className="h-100 classbgcard">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>3. Penerima Informasi (Wali)</small>
		</CCardHeader>

		<CCardBody className="">
			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Wali Sebagai</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<div onClick={()=>hdlKlikEditconsent("kuasa_id")} className="classconsentklikedit d-lg-inline-block">
				{UFunc.renderHTML(vKuasaObj.kuasa_sebagai || uHTMLeditable)}
				</div>
			</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Nama Wali</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				{uDatamainObj.nama_kuasa || "Undf Nama Wali"}
			</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Umur / Sex</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				{vKuasaObj.umur|| "UNDF"} th
				<span> &middot; </span>
				<b>{vKuasaObj.sex_label|| "Laki-laki"}</b>
			</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>Alamat</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<i>{UFunc.renderHTML(vKuasaObj.alamat || "-")}</i>
			</CCol>
			</CRow>

			<CRow className="my-2 my-md-3">
			<CCol xs="4" md="5" className=""><small>NIK</small></CCol>
			<CCol className="text-primary text-end text-md-start">
				<b>{vKuasaObj.nik|| "-"}</b>
			</CCol>
			</CRow>
		</CCardBody>
		</CCard>
		)//>
	}
	const contentParagraf = () => {
		if(uHtml500msg) return "";

		const vVariabelArr 		= uDatamainObj.variabelarr || [];
		const vKuasaObj			= uDatamainObj.kuasa_obj || {};

		return (
		<>
		<CCard className="classbgcard mb-3">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>4. Isi Consent</small>
		</CCardHeader>

		<CCardBody className="px-0">
			<div className="px-2 px-lg-5">
			<ol className="ps-4">
			<li><b>PEMBERIAN INFORMASI</b>
				<ol className="mt-2" style={{listStyleType:"none", padding: 0}}>
				<li style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
					<span>1.1.</span>
					<span>
					Yang bertanda tangan di bawah ini telah mendapatkan informasi tentang operasi / tindakan: {uDatamainObj.nama_tindakan 
						? (<b className="text-uppercase">{uDatamainObj.nama_tindakan}</b>) 
						: (<span className='text-muted'>[NAMA TINDAKAN]</span>)}.

					<p>Yang dilaksanakan oleh dokter: {uDatamainObj.nama_dokter 
						? (<b className="text-uppercase">{uDatamainObj.nama_dokter}</b>) 
						: (<span className='text-muted'>[NAMA DOKTER]</span>)}.</p>

					<p>Diagnosis, indikasi, tata cara, tujuan, alternative tindakan, 
					risiko, komplikasi yang mungkin dapat terjadi dari tindakan tersebut 
					dan prognosis terhadap tindakan telah dijelaskan kepada saya oleh dokter tersebut diatas.</p>

					<p>Saya juga telah dijelaskan mengenai:
					<ul>
						<li><div>Manfaat dari tindakan yang dilakukan, seperti:</div>
							<div className="classconsentklikedit" onClick={()=>hdlKlikEditconsent("variabelarr",0)}>
							{UFunc.renderHTML((vVariabelArr[0]||{}).content || uHTMLeditable)}
							</div>
						</li>

						<li><div>Pilihan tindakan alternatif, seperti:</div>
							<div className="classconsentklikedit" onClick={()=>hdlKlikEditconsent("variabelarr",1)}>
							{UFunc.renderHTML((vVariabelArr[1]||{}).content || uHTMLeditable)}
							</div>
						</li>
					</ul>
					</p>
					</span>
				</li>

				<li style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
					<span>1.2.</span>
					<span>Yang bertanda tangan di bawah ini juga menyatakan telah mendapat informasi tentang:
					<p>
					<ul>
					<li>Transfusi darah dan produk-produk lain dari darah, bila dirasa perlu oleh dokter.</li>
					<li>Ahli bedah yang bertugas mencari konsultasi atau mendapat bantuan dari dokter lain yang berkaitan jika dirasakan perlu, selama pelaksanaan tindakan atau operasi berlangsung.</li>
					<li>Pasien dapat dirawat di ruang intensif setelah operaasi sesuai kondisi pasien, perawatan intensif dan tindakan medis yang lazimnya dilakukan di perawat intensif.</li>
					<li>Bila perawat kamar bedah mengalami luka tusuk / terpapar cairan tubuh pasien, pasien setuju untuk diperiksa darahnya</li>
					</ul>
					</p>
					</span>
				</li>

				<li style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
					<span>1.3.</span>
					<span>
					<p>RISIKO DARI TINDAKAN YANG AKAN DILAKSANAKAN</p>
					<p>Risiko yang dapat terjadi antara lain: reaksi alergi, pendarahan, pembekuan darah, infeksi, efek samping dari penggunaan obat-obat, atau bahkan hilangnya sebagian dari fungsi tubuh dan kematian.</p>
					<p><div>Risiko lainnya yang dapat terjadi:</div>
						<div className="classconsentklikedit" onClick={()=>hdlKlikEditconsent("variabelarr",2)}>
							{UFunc.renderHTML((vVariabelArr[2]||{}).content || uHTMLeditable)}
						</div>
					</p>
					</span>
				</li>
				</ol>
			</li>

			<li><b>PERSETUJUAN TINDAKAN MEDIK / BEDAH</b>
				<ol className="mt-2" style={{listStyleType:"none", padding: 0}}>
				<li style={{ display: 'flex', gap: '10px', marginBottom: '4px' }}>
					<span>2.1.</span>
					<p>Saya memahami dan mengerti dengan jelas mengenai informasi dan penjelasan tindakan yang disampaikan.</p>
				</li>

				<li style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
					<span>2.2.</span>
					<p>Saya menyadari sepenuhnya bahwa pada tindakan medis, berbagai risiko dan komplikasi yang tidak didiskusikan sebelumnya mungkin dapat timbul. Saya juga menyadari bahwa selama berlangsunya tindakan tersebut ada kemungkinan timbul kondisi-kondisi yang tidak terduga dimana hal tersebut memerlukan tindakan-tindakan perluasan operasi yang berhubungan dengan operasi yang sedang dilakukan, untuk itu saya menyetujui dilakukannya tindakan tersebut apabila diperlukan. Selanjutnya saya menyadari bahwa tidak ada jaminan atau janji-janji yang diberikan kepada saya sehubungan dengan hasil dari segala tindakan dan atau perawatan.</p>
				</li>

				<li style={{ display: 'flex', gap: '10px', }}>
					<span>2.3.</span>
					<span>Saya menyetujui pelaksanaan dari tindakan yang dijelaskan di atas.</span>
				</li>
				</ol>
			</li>
			</ol>
			</div>
		</CCardBody>
		</CCard>

		<CCard className="classbgcard mb-3">
		<CCardBody className="px-0">
			{(parseInt(uDatamainObj.kuasa_id)||0) === 1 ? (
			<div className="px-3 px-lg-5">
				<p>Semua Hal Diatas Telah Disetujui Oleh Pasien.</p>
			</div>
			) : (
			<div className="px-2 px-lg-5">
				<p>Bila pasien berusia di bawah usia 21 tahun atau tidak dapat memberikan persetujuan karena alasan lain (*) tidak dapat menandatangani surat diatas, pihak OMNI Dental Clinic dapat mengambil kebijaksanaan dengan memperoleh tandatangan dari orang tua, pasangan, anggota keluarga terdekat atau wali dari pasien.</p>
				<p><div>(*) Jelaskan alasan lainnya:</div>
					<div onClick={()=>hdlKlikEditconsent("variabelarr",3)} className="classconsentklikedit">
						{UFunc.renderHTML((vVariabelArr[3]||{}).content || uHTMLeditable)}
					</div>
				</p>

				<p>Saya {vKuasaObj.kuasa_sebagai 
					? (<b className="text-uppercase">{vKuasaObj.kuasa_sebagai}</b>) 
					: (<span className="text-muted">[Undf Jenis Kuasa]</span>)} dari pasien {uDatamainObj.nama_pasien 
					? (<b className="text-uppercase">{uDatamainObj.nama_pasien}</b>) 
					: (<span className="text-muted">[Undf Pasien]</span>)}:</p>

				<ul>
					<li>Membenarkan bahwa saya memiliki hak untuk menandatangani form consent atas nama pasien.</li>
					<li>Telah membaca, memahami & menerima semua informasi pada form persetujuan ini.</li>
					<li>Memastikan bahwa saya telah diberi penjelasan dan mengerti dengan baik tentang tindakan tersebut</li>
				</ul>
			</div>
			)}
		</CCardBody>
		</CCard>
		</>
		)//>
	}
	const contentSignature = () => {
		if(uHtml500msg) return "";

		const vDokterObj		= uDatamainObj.dokter_obj || {};
		const vKuasaObj			= uDatamainObj.kuasa_obj || {};
		const vSaksikeluargaObj	= uDatamainObj.saksikeluarga_obj || {};
		const vSaksiklinikObj	= uDatamainObj.saksiklinik_obj || {};

		//console.log("contentSignature url_tandatangan",vDokterObj.url_tandatangan);

		return (
		<>
		<CCard className="mb-3 d-md-none bg-light">
		<CCardBody className="py-1">
			<small>5. Tanda Tangan</small>
		</CCardBody>
		</CCard>

		<CCard className="classbgcard mb-3">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>Dokter Pelaksana</small>
		</CCardHeader>
		
		<CCardBody>
			<div className="d-none">{vDokterObj.url_tandatangan}</div>
			<CRow className="align-items-stretch">
			<CCol md="7" className="d-none d-md-block">
				<small>Dokter Pelaksana Tindakan</small>
			</CCol>

			<CCol className="">
			<div onClick={()=>hdlKlikEditsignature("dokter_obj")} 
				style={{minHeight:125}} 
				className="classconsentklikedit d-flex justify-content-center align-items-center">
				{(vDokterObj.url_tandatangan) ? (
					<img src={vDokterObj.url_tandatangan} height="98%" style={{maxWidth:275,maxHeight:150}}/>
				) : (
				<>
				{UFunc.renderHTML("<span>"+uHTMLeditable+"</span>")}
				</>
				)}
			</div>
			
			<div className="fw-bolder text-center text-uppercase">
				({vDokterObj.label_nama || UFunc.renderHTML("<small class='text-muted fst-italic fw-normal'> Nama Terang </small>")})
			</div>
			</CCol>
			</CRow>
		</CCardBody>
		</CCard>

		<CCard className="classbgcard mb-3">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>Penerima Informasi (Wali)</small>
		</CCardHeader>
		
		<CCardBody>
			<CRow>
			<CCol md="7" className="d-none d-md-block">
				<small>Penerima Informasi (Wali)</small>
			</CCol>

			<CCol className="">
			<div onClick={()=>hdlKlikEditsignature("kuasa_obj")} 
				style={{height:125}} 
				className="classconsentklikedit d-flex justify-content-center align-items-center">
				{(vKuasaObj.url_tandatangan) ? (
					<img src={vKuasaObj.url_tandatangan} height="98%" style={{maxWidth:275,maxHeight:150}}/>
				) : (
				<>
				{UFunc.renderHTML("<span>"+uHTMLeditable+"</span>")}
				</>
				)}
			</div>

			<div className="fw-bolder text-center text-uppercase">
				({vKuasaObj.label_nama || UFunc.renderHTML("<small class='text-muted fst-italic fw-normal'> Nama Terang </small>")})
			</div>
			</CCol>
			</CRow>
		</CCardBody>
		</CCard>

		<CCard className="classbgcard mb-3">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>Saksi Keluarga</small>
		</CCardHeader>
		
		<CCardBody>
			<CRow>
			<CCol md="7" className="d-none d-md-block">
				<small>Saksi Keluarga</small>
			</CCol>

			<CCol>
			<div onClick={()=>hdlKlikEditsignature("saksikeluarga_obj")} 
				style={{height:125}} 
				className="classconsentklikedit d-flex justify-content-center align-items-center">
				{(vSaksikeluargaObj.url_tandatangan) ? (
					<img src={vSaksikeluargaObj.url_tandatangan} height="98%" style={{maxWidth:275,maxHeight:150}}/>
				) : (
				<>
				{UFunc.renderHTML("<span>"+uHTMLeditable+"</span>")}
				</>
				)}
			</div>

			<div className="fw-bolder text-center text-uppercase">
				({vSaksikeluargaObj.label_nama || UFunc.renderHTML("<small class='text-muted fst-italic fw-normal'> Nama Terang </small>")})
			</div>
			</CCol>
			</CRow>
		</CCardBody>
		</CCard>

		<CCard className="classbgcard">
		<CCardHeader className="py-0 pt-1 d-md-none">
			<small>Saksi Klinik</small>
		</CCardHeader>
		
		<CCardBody>
			<CRow>
			<CCol md="7" className="d-none d-md-block">
				<small>Saksi Klinik</small>
			</CCol>

			<CCol>
			<div onClick={()=>hdlKlikEditsignature("saksiklinik_obj")} 
				style={{height:125}} 
				className="classconsentklikedit d-flex justify-content-center align-items-center">
				{(vSaksiklinikObj.url_tandatangan) ? (
					<img src={vSaksiklinikObj.url_tandatangan} height="98%" style={{maxWidth:275,maxHeight:150}}/>
				) : (
				<>
				{UFunc.renderHTML("<span>"+uHTMLeditable+"</span>")}
				</>
				)}
			</div>

			<div className="fw-bolder text-center text-uppercase">
				({vSaksiklinikObj.label_nama || UFunc.renderHTML("<small class='text-muted fst-italic fw-normal'> Nama Terang </small>")})
			</div>
			</CCol>
			</CRow>
		</CCardBody>
		</CCard>
		</>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow && !uISDlgformFsshow) return (<></>)//>

		const vNamafield = uDlgformObj.dlg_jenis || "";

		let vTitel;
		if(vNamafield === "nama_tindakan")	
			vTitel = "Nama Tindakan";
		else if(vNamafield === "kuasa_id")	
			vTitel = "Wali (Kuasa) Sebagai";
		else if(vNamafield === "id_pasien")	
			vTitel = "Nama Pasien";
		else if(vNamafield === "variabelarr")	
			vTitel = "Penjelasan";

		//--INPUT_TEXT--/
		if(uDlgformObj.dlg_input === "ONE") return (
		<CForm className="h-25 h-lg-auto d-flex align-items-center">
			<div className="w-100">
			<CRow className="my-2">
			<CCol md="4" className="">{vTitel}</CCol>
			<CCol>
				<CFormInput size="sm"
					value={uDlgformObj[vNamafield]}
					onChange={(e)=>setDlgformObj({...uDlgformObj,[vNamafield]:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpforminputteks"/>
				{vNamafield === "nama_tindakan" && (
				<div className="classpetunjuk">*) Data NAMA TINDAKAN Dapat Diubah-ubah..</div>
				)}
			</CCol>
			</CRow>
			</div>
		</CForm>
		)//>
		//--END INPUT_TEXT--/

		//--INPUT_TEXTAREA--/
		if(uDlgformObj.dlg_input === "textarea") return (
		<CForm className="h-50 h-lg-auto d-flex align-items-center">
			<div className="w-100">
			<CRow className="my-2">
			<CCol md="4" className="">{vTitel}</CCol>
			<CCol>
				<CFormTextarea size="sm"
					rows={5}
					value={UFunc.br2nl(uDlgformObj.isi_textarea)}
					onChange={(e)=>setDlgformObj({...uDlgformObj,isi_textarea:UFunc.nl2br(e.target.value)})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpforminputteks"/>
				{!isMobile && (
				<div className="classpetunjuk">*) {uBahasaObj.petunjuk_textarea}</div>
				)}
			</CCol>
			</CRow>
			</div>
		</CForm>
		)//>
		//--END INPUT_TEXTAREA--/
	
		//--INPUT_KUASA--/
		if(uDlgformObj.dlg_jenis === "id_pasien") return (
		<CForm className="">
			<CRow className="my-2">
			<CCol md="4">Nama Pasien</CCol>
			<CCol className="fw-bolder text-primary">{uDlgformObj.label_nama}</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="4">NIK</CCol>
			<CCol className="fw-bolder text-primary">{uDlgformObj.nik || "-"}</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="4">Umur / Jenis Kelamin</CCol>
			<CCol className="d-flex align-items-start">
				<CInputGroup style={{width:100}} size="sm">
				<CFormInput size="sm" type="number"
					value={uDlgformObj.umur}
					onChange={(e)=>setDlgformObj({...uDlgformObj,umur:e.target.value})}
					id="inpformpasienumur"/>
				<CInputGroupText>Thn</CInputGroupText>
				</CInputGroup>
				<span className="mx-2">&middot;</span>
				<span className="text-primary">{uDlgformObj.sex_label||"Laki-laki"}</span>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="4">Alamat</CCol>
			<CCol>
				<CFormInput size="sm" maxLength={255}
					value={uDlgformObj.alamat}
					onChange={(e)=>setDlgformObj({...uDlgformObj,alamat:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpformpasienalamat"/>
			</CCol>
			</CRow>
		</CForm>
		)//>
		//--END INPUT_KUASA--/
	
		//--INPUT_KUASA--/
		if(uDlgformObj.dlg_jenis === "kuasa_id") return (
		<CForm className="">
			<CRow className="my-2">
			<CCol md="4">{vTitel}</CCol>
			<CCol>
			{uDatakuasaArr.map((vItems,vKeys)=>{
				return (
				<React.Fragment key={vKeys}>
					{(vKeys >= uDatakuasaArr.length-1) && (
						<br/>
					)}

					<CBadge color="secondary" className="py-2 mb-1 text-start">
					<input type="radio" 
						className="align-middle"
						checked={parseInt(uDlgformObj.kuasa_id) === parseInt(vItems.id)} 
						onChange={(e)=>setDlgformObj({...uDlgformObj,kuasa_id:e.target.value})}
						value={vItems.id}
						name="inpkuasaid" 
						id={"inpkuasaid"+vItems.id}/>
					<label htmlFor={"inpkuasaid"+vItems.id} 
						className="px-2 d-inline-block"
						style={{minWidth:(vKeys >= uDatakuasaArr.length-1 ? "auto":100),}}>
						{vItems.nama_kuasa}
					</label>
					
					{(vKeys >= uDatakuasaArr.length-1) && (
						<CFormInput size="sm" maxLength={15}
							readOnly={parseInt(uDlgformObj.kuasa_id) !== 6}
							value={uDlgformObj.kuasa_lainnya}
							onChange={(e)=>setDlgformObj({...uDlgformObj,kuasa_lainnya:e.target.value})}						
							className="d-inline-block w-auto" 
							id="inpkuasalainnya"/>
					)}
					</CBadge>
					
					{(vKeys < uDatakuasaArr.length-2) && (
						<span className=""> &middot; </span>
					)}
				</React.Fragment>
				)//>
			})}
			</CCol>
			</CRow>

			<div className="classborderbottom my-3"/>

			<CRow className="my-2">
			<CCol md="4">Nama Penerima Wali</CCol>
			<CCol>
				<CFormInput size="sm" maxLength={100}
					readOnly={parseInt(uDlgformObj.kuasa_id)===1}
					value={uDlgformObj.label_nama}
					onChange={(e)=>setDlgformObj({...uDlgformObj,label_nama:e.target.value})}
					id="inpkuasanama"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="4">Umur / Jenis Kelamin</CCol>
			<CCol className="d-flex align-items-start">
				<CInputGroup style={{width:100}} size="sm">
				<CFormInput size="sm" type="number"
					readOnly={parseInt(uDlgformObj.kuasa_id)===1}
					value={uDlgformObj.umur}
					onChange={(e)=>setDlgformObj({...uDlgformObj,umur:e.target.value})}
					id="inpkuasaumur"/>
				<CInputGroupText>Thn</CInputGroupText>
				</CInputGroup>

				<span className="mx-2">&middot;</span>
				
				<CFormSelect size="sm"
					className="w-auto"
					value={uDlgformObj.sex_label}
					onChange={(e)=>setDlgformObj({...uDlgformObj,sex_label:e.target.value})}
					disabled={parseInt(uDlgformObj.kuasa_id)===1}
					id="inpkuasasex">
					<option value="Laki-laki">Laki-laki</option>
					<option value="Perempuan">Perempuan</option>
				</CFormSelect>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="4">Alamat</CCol>
			<CCol>
				<CFormInput size="sm" maxLength={255}
					readOnly={parseInt(uDlgformObj.kuasa_id)===1}
					value={uDlgformObj.alamat}
					onChange={(e)=>setDlgformObj({...uDlgformObj,alamat:e.target.value})}
					id="inpkuasaalamat"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="4">NIK</CCol>
			<CCol>
				<CFormInput size="sm" maxLength={255}
					readOnly={parseInt(uDlgformObj.kuasa_id)===1}
					value={uDlgformObj.nik}
					onChange={(e)=>setDlgformObj({...uDlgformObj,nik:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpkuasanik"/>
			</CCol>
			</CRow>
		</CForm>
		)//>
		//--END INPUT_KUASA--/
	
		//--INPUT_SIGNATURE--/
		if(uDlgformObj.dlg_input === "signature") return (
		<CForm className={isMobile ? "h-100" : ""} style={{height:window.innerHeight-230}}>
			<div ref={uRefparentcanvas} 
				style={{
					minHeight:290,
					height:(isMobile?"auto":"50%"),
					backgroundColor:"#f0f0f033",
				}}
				className="mb-1 mx-auto border border-dark border-2 rounded">
			<SignatureCanvas
				canvasProps={{ 
					width: 200,
					height: 150,
					className: "uRefcanvas",
					style: { 
						width: "100%", 
						height: "100%",
						display: "block", 
						objectFit: "contain",
					}
				}}
				ref={(ref) => { uRefcanvas.current = ref; }}/>
			</div>

			<div align="center">
				<CLink onClick={()=>{uRefcanvas.current.clear()}} className="classcursorpointer">
				<CIcon icon="cilReload" className="classikonbox" height={23}/>
				</CLink>

				<span> &middot; </span>

				{(isMobile) ? (
				<span className="classpetunjuk px-0">Jangan Ubah Orientasi Screen Anda</span>
				) : (
				<span className="classpetunjuk px-0">Tanda Tangan</span>
				)}
			</div>

			<div className="my-3 classborderbottom"/>

			{(uDlgformObj.dlg_jenis === "dokter_obj" 
				|| uDlgformObj.dlg_jenis === "kuasa_obj") ? (
				<div className="fw-bolder my-2 text-center">
				( {uDlgformObj.label_nama||"Undf Nama"} )
				</div>
			) : (
				<CRow className="my-2">
				<CCol md="4">Nama Terang</CCol>
				<CCol>
				<CFormInput size="sm"
					value={uDlgformObj.label_nama}
					onChange={(e)=>setDlgformObj({...uDlgformObj,label_nama:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpforminputteks"/>
				</CCol>
				</CRow>
			)}
		</CForm>
		)//>
		//--END INPUT_SIGNATURE--/

		return (<></>)//>
	}
	const contentHTMLcetak = () => {
		let vHTMLs 	= `
		<html>
		<head>
		<style>
		@media print {
			@page {
				size: auto;
				margin: 5mm !important;
			}
			body {
				margin: 0; pading: 0;
			}
			table.classtabelhtml,
				table.classtabelmaster {
				font-family: Arial, Helvetica, Sans Serif;/**/
				font-size: 12pt;
				width:100%;
				margin: 0 auto;
				border-spacing: 0;
				display: table;
			}
			table.classtabelmaster thead {
				display: table-header-group; /* This is the key property */
			}
			table.classtabelhtml {
				page-break-inside: avoid;
				page-break-after: auto;
				display: table; 
			}
			table.classtabelhtml caption {
			}
			table.classtabelhtml tbody td {
				overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all;
				word-break: break-all; word-break: break-word;
				-ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto;
				hyphens: auto;
			}
			table.classtabelhtml tbody td {
				padding: 2mm;
			}
		}
		</style>
		</head>
		`;

		const vVariabelArr 		= uDatamainObj.variabelarr || [];
		const vKuasaObj			= uDatamainObj.kuasa_obj || {};
		const vDatapasienObj	= uDatamainObj.pasien_obj || {};
		const vDokterObj		= uDatamainObj.dokter_obj || {};
		const vSaksiklinikObj	= uDatamainObj.saksiklinik_obj || {};
		const vSaksikeluargaObj	= uDatamainObj.saksikeluarga_obj || {};

		const vHTMLcontentmainArr	= uHTMLcontentmainArr.map(vItems=>{
			let vHTMLstr 	= vItems;
			vHTMLstr		= vHTMLstr.replace(new RegExp("_NAMATINDAKAN_","ig"),(uDatamainObj.nama_tindakan||"<span class='text-muted'>[Undf Tindakan]</span>"));
			vHTMLstr		= vHTMLstr.replace(new RegExp("_NAMADOKTER_","ig"),(uDatamainObj.nama_dokter||"<span class='text-muted'>[Undf Dokter]</span>"));

			vVariabelArr.forEach((vItemvars)=>{
				const vVars 	= vItemvars.nama_vars || "";
				vHTMLstr		= vHTMLstr.replace(new RegExp(vVars,"ig"),(vItemvars.content || "-"));
			});

			return vHTMLstr;
		});
		
		let vHTMLcontentpersetujuan	= uHTMLpersetujuan;
		vHTMLcontentpersetujuan		= vHTMLcontentpersetujuan.replace(new RegExp("_JENISKUASA_","ig"),(vKuasaObj.kuasa_sebagai||"<span class='text-muted'>[Jenis Kuasa]</span>"));
		vHTMLcontentpersetujuan		= vHTMLcontentpersetujuan.replace(new RegExp("_NAMAPASIEN_","ig"),(uDatamainObj.nama_pasien||"<span class='text-muted'>[Undf Pasien]</span>"));

		vVariabelArr.forEach((vItems,vKeys)=>{
			const vVars 	= vItems.nama_vars || "";
			vHTMLcontentpersetujuan		= vHTMLcontentpersetujuan.replace(new RegExp(vVars,"ig"),(vItems.content || "-"));
		})

		vHTMLs	+= `
		<body>
		<table class="classtabelmaster">
		<thead>
			<tr>
			<th width="45%" align="center">_LOGO_</th>
			<th align="right" style="font-size:smaller;font-weight:normal;padding:3mm;">
				_IDENTITASKLINIK_
			</th>
			</tr>
		</thead>

		<tbody>
		<tr>
		<td colspan="2">
			<table class="classtabelhtml" padding="20" border="1">
			<tbody>
				<tr valign="middle">
					<td align="center" style="font-size:larger;">
					<b>PEMBERIAN INFORMASI DAN PERSETUJUAN TINDAKAN MEDIK / BEDAH</b>
				</td>
				</tr>
			</tbody>
			</table>
		`;

		vHTMLs += vHTMLcontentmainArr.map(vItems => {
			return (`
			<table class="classtabelhtml" border="1">
			<tbody>
				<tr>
					<td align="left">`+vItems+`</td>
				</tr>
			</tbody>
			</table>
			`);
		}).join(``);

		vHTMLs += `
			<div>&nbsp;</div>

			<table class="classtabelhtml" border="1">
			<tbody>
				<tr valign="top">
					<td align="left">`+
						((parseInt(uDatamainObj.kuasa_id)||0) === 1 
							? `
							<p>Semua Hal Diatas Telah Disetujui Oleh Pasien.</p>
							`
							: vHTMLcontentpersetujuan+
							``)+`

						<table width="100%" cellpadding="2" border="0" align="center">
						<tbody>
						<tr>
							<td width="50%" align="center">`+
								(uSystemconfigObj.kota||"Palembang")+`, `+
								UFunc.TglAngka(uDatamainObj.tgl_consent)+`
							</td>

							<td align="center">Pukul: `+UFunc.JamMenit(uDatamainObj.tgl_consent)+`</td>
						</tr>

						<tr valign="top">
							<td align="center">
								<div>_TTDKUASA_</div>
								<div style="border-bottom:1px solid black;display:inline-block;text-transform:uppercase">(`+uDatamainObj.nama_kuasa+`)</div>
							</td>
							
							<td align="center">
								<div>_TTDSAKSIKELUARGA_</div>
								<div style="border-bottom:1px solid black;display:inline-block;text-transform:uppercase">(`+(vSaksikeluargaObj.label_nama || "<i style='color:#f0f0f0;'>Saksi Keluarga</i>")+`)</div>
							</td>
						</tr>

						<tr valign="top">
							<td align="center">
								<div>_TTDDOKTER_</div>
								<div style="border-bottom:1px solid black;display:inline-block;text-transform:uppercase">(`+uDatamainObj.nama_dokter+`)</div>
							</td>
							
							<td align="center">
								<div>_TTDSAKSIKLINIK_</div>
								<div style="border-bottom:1px solid black;display:inline-block;text-transform:uppercase">(`+(vSaksiklinikObj.label_nama || "<i style='color:#f0f0f0;'>Saksi Klinik</i>")+`)</div>
							</td>
						</tr>
						</tbody>
					</table>
					</td>
				</tr>
			</tbody>
			</table>
		</td>
		</tr>
		</tbody>
		</table>
		</body>
		</html>
		`;

		return vHTMLs;
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoadawal = async() => {
		/*//--ALUR--/
		1. Data Dokter
		2. Data Pasien
		3. Data Jenis Kuasa
		//-END -ALUR--*/

		setHtml500msg();
		setDatamainObj({});
		setDatadokterObj({});
		setDatapasienObj({});
		setLoading(true);
		try {
			setSessionaktif(false);
			const vHeaderObj = {
				headers: { Accept: "application/json", "Content-Type": "application/json" },
				method: "POST",
				mode: "cors",
				cache: "default",
			}

			setTimeelapse(0);
			const vTimeBegin = new Date();
			const [output_dokter,output_pasien,output_kuasa] = await Promise.all([
				(async () => {
					const vURLs	= pjson.homepage+"api/api_consent/ld_dokter";
					const vDATAS= JSON.stringify({
						send_dokterid: uDokterID,
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),
				(async () => {
					const vURLs	= pjson.homepage+"api/api_consent/ld_pasien";
					const vDATAS= JSON.stringify({
						send_pasienid: uPasienID,
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),
				(async () => {
					const vURLs	= pjson.homepage+"api/api_consent/ld_kuasa";
					const vDATAS= JSON.stringify({
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),
			]);
			
			setSessionaktif(true);
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setTimeelapse(vTimeDiff);

			//--DOKTER--/
			if(output_dokter.tampil) {
				const vTmpObj	= JSON.parse(output_dokter.dataobj_str || "{}");
				//console.log("(Consent - apiLoadawal) output_dokter : ",vTmpObj);
				setDatadokterObj({
					id_dokter: uDokterID,
					nama_dokter: vTmpObj.nama_dokter,
					dokter_obj: { label_nama:vTmpObj.nama_dokter }
				})
			} else if(output_dokter.info) {
				setHtml500msg(output_dokter.info);
			} else if(output_dokter.errors) {
				console.log("(Consent - apiLoadawal) output_dokter.errors : "+output_dokter.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_dokter.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_dokter.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DOKTER--/

			//--PASIEN--/
			if(output_pasien.tampil) {
				const vTmpObj	= JSON.parse(output_pasien.dataobj_str || "{}");
				setDatapasienObj({
					id_pasien: uPasienID,
					nama_pasien: vTmpObj.nama_pasien,
					pasien_obj: { 
						label_nama:vTmpObj.nama_pasien,
						umur: parseInt(vTmpObj.umur)||0,
						sex_label: vTmpObj.sex_pasien==="L" ? "Laki-laki" : "Perempuan",
						alamat: vTmpObj.alamat,
						nik: vTmpObj.nik,
					}
				})
			} else if(output_pasien.info) {
				setHtml500msg(output_pasien.info);
			} else if(output_pasien.errors) {
				console.log("(Consentform2 - apiLoadawal) output_pasien.errors : "+output_pasien.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_pasien.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_pasien.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END PASIEN--/

			//--KUASA--/
			if(output_kuasa.tampil) {
				const vTmpArr	= JSON.parse(output_kuasa.dataarr_str || "{}");
				setDatakuasaArr(vTmpArr);
			} else if(output_kuasa.info) {
				setHtml500msg(output_kuasa.info);
			} else if(output_kuasa.errors) {
				console.log("(Consentform2 - apiLoadawal) output_kuasa.errors : "+output_kuasa.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_kuasa.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_kuasa.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END KUASA--/
		} catch (error) {
			console.log("(Consentform2 - apiLoadawal) catch-error : "+error.message);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		} finally {
			setLoading(false);
		}
	}
	const apiProsessimpan = () => {
		const vElsimpan	= document.getElementById("btnSimpanmain");
		vElsimpan && (vElsimpan.disabled = true);
		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			showToast(uBahasaObj.pesan_periksasukses||"Berhasil","SUKSES");
			//uNavigate(uUrlbefore,{replace:true});
		},2500);return;//-*/

		let vContent	= contentHTMLcetak();
		const vUrllogo	= (pjson.homepage+"api/images/logo_default.png");
		const vImglogo	= "<img src='"+vUrllogo+"' style='width:40mm;'/>";
		const vIdentitasklinik	= uHTMLIdentitasklinik;

		vContent	= vContent.replace(new RegExp("_LOGO_","ig"),vImglogo);
		vContent	= vContent.replace(new RegExp("_IDENTITASKLINIK_","ig"),vIdentitasklinik);
		vContent	= vContent.replace(new RegExp("_TELPHP_","ig"),"Telp."+(uSystemconfigObj.telp_hp||"0812-1515-6161")+"");
		vContent	= vContent.replace(new RegExp("_EMAIL_","ig"),(uSystemconfigObj.email||"omniklinikgigi@gmail.com"));
		vContent	= vContent.replace(new RegExp("_ALAMATKLINIK_","ig"),UFunc.br2nl(uSystemconfigObj.alamat_klinik||"Palembang - Sumatera Selatan"));

		const vDATAS	= JSON.stringify({
			send_datamainstr : JSON.stringify({...uDatamainObj,
				url_logo: vUrllogo,
				content_html: (vContent).replace(/[\t\n\r]+/g, ''),
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_consent/pr_simpanmain";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				showToast((uBahasaObj.pesan_consentsukses||"Berhasil"),"SUKSES");

				const vURLnext = uURLdone ? uURLdone : uUrlbefore;
				uNavigate(vURLnext,{replace:true}); return;
			} else {
				vElsimpan && (vElsimpan.disabled = false);
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Consentform2 - apiProsessimpan) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired(); return;
				}
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);

			console.log("(Consentform2 - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}
	const apiLoadtindakan = (_OBJTINDAKAN) => {
		_OBJTINDAKAN = _OBJTINDAKAN || {};
		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
		},2500);return;//-*/

		const vDATAS	= JSON.stringify({
			send_tindakanid: parseInt(_OBJTINDAKAN.id)||0,
			send_tindakanlabel:(_OBJTINDAKAN.caption||"").trim(),
			send_dokterid: uDokterID,
			send_jenisid: uJenisconsentID,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_consent/ld_tindakancontent";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				console.log("(Consentform2 - apiLoadtindakan) output_string: ",output_string);
				setDlgformObj({
					dlg_header: "Nama Tindakan",
					dlg_jenis: "nama_tindakan",
					dlg_input: "ONE",
					dlg_indeks: -1,
					nama_tindakan: (_OBJTINDAKAN.caption||"").trim(),
					id_tindakan: parseInt(output_string.tindakan_id)||0,
					content_str: output_string.contenttindakan_str,//-->ARRAY_ATO_OBJ_MENYESUAIKAN--/
				});

				if(!isMobile) {
					setDlgformshow(true);

					let vTimeout = setTimeout(() => {
						clearTimeout(vTimeout);
						const vElfocus 	= document.getElementById("inpforminputteks");
						vElfocus && vElfocus.focus();
					}, 350);
				} else setDlgformFsshow(true);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Consentform2 - apiLoadtindakan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}
		})
		.catch((error) =>{
			setLoading(false);

			console.log("(Consentform2 - apiLoadtindakan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		setDatadefaultObj({...uDefaultvarObj});

		apiLoadawal();

		return () => {
			setDatamainObj({});setDatadokterObj({}); setDatapasienObj({}); setDatakuasaArr([]);
			setDlgformshow(false);setDlgformFsshow(false); setDlglookupconsentshow(false);
			setDatadefaultObj({});
			//--TESTING_DITUTUP--/
			uDispatch({type: "set", gConsentcreateObj: undefined});
			//--END TESTING_DITUTUP--*/
		}
	},[])
	React.useEffect(()=>{
		let vTmpObj	= {}
		if(uDatadokterObj.id_dokter !== undefined) {
			vTmpObj = {...vTmpObj,
				id_dokter: uDatadokterObj.id_dokter,
				nama_dokter: uDatadokterObj.nama_dokter,
				dokter_obj: uDatadokterObj.dokter_obj,
			}

			setDatadokterObj({});
		}

		if(uDatapasienObj.id_pasien !== undefined) {
			vTmpObj = {...vTmpObj,
				id_pasien: uDatapasienObj.id_pasien,
				nama_pasien: uDatapasienObj.nama_pasien,
				pasien_obj: uDatapasienObj.pasien_obj,
			};//-*/

			setDatapasienObj({});
		}

		if(uDatadokterObj.id_dokter !== undefined || uDatadokterObj.id_dokter !== undefined)
			setDatadefaultObj({...uDatadefaultObj,...vTmpObj});//-*/
	},[uDatadokterObj.id_dokter,uDatapasienObj.id_pasien])
	React.useEffect(()=>{
		if(uDatadefaultObj.nama_pasien === undefined) return;

		const vDatapasienObj	= uDatadefaultObj.pasien_obj || {};
		const vKuasaObj 		= {
			kuasa_sebagai: "Saya (Sendiri)",
			label_nama: uDatadefaultObj.nama_pasien,
			umur: vDatapasienObj.umur,
			sex_label: vDatapasienObj.sex_label,
			alamat: vDatapasienObj.alamat,
			nik: vDatapasienObj.nik,
		}

		const vTmpObj = {
			kuasa_id: 1,
			nama_kuasa: uDatadefaultObj.nama_pasien,
			kuasa_obj: vKuasaObj,
		}
		setDatadefaultObj({...uDatadefaultObj,...vTmpObj});
	},[uDatadefaultObj.nama_pasien]);
	React.useEffect(()=>{
		//console.log("(Consentform2 - [uDatadefaultObj])  ",uDatadefaultObj);
		setDatamainObj({...uDatadefaultObj,
			variabelarr: [...((uDatadefaultObj||{}).variabelarrdefault||[])],
			variabelarrdefault:undefined
 		});
	},[uDatadefaultObj]);
	React.useEffect(()=>{
		if(!uISDlgformshow) { 
			uRefcanvas.current?.clear?.();
			setDlgformObj({});
			return 
		}
		
		let vTimeout = setTimeout(() => {
			clearTimeout(vTimeout);

			const vElsbutton = document.getElementById("btnDialogSimpan");
			vElsbutton && (vElsbutton.innerHTML="OK !");

			if(uDlgformObj.dlg_input === "signature") {
				initResizecanvas();
			}
		}, 100);

		/*
		window.addEventListener('resize', initResizecanvas);
		return () => {
	        window.removeEventListener('resize', initResizecanvas);
	      };//-*/
	},[uISDlgformshow]);
	React.useEffect(()=>{
		if(!uISDlgformFsshow) { 
			uRefcanvas.current?.clear?.();
			setDlgformObj({});
			return 
		}

		let vTimeout = setTimeout(() => {
			clearTimeout(vTimeout);
			if(uDlgformObj.dlg_input === "signature") initResizecanvas();
		}, 100);

		/*window.addEventListener('resize', initResizecanvas);
		return () => {
	        window.removeEventListener('resize', initResizecanvas);
	      };//-*/
	},[uISDlgformFsshow]);
	React.useEffect(()=>{
		if(!uISDlglookupconsentshow) 
			{ setDlglookupconsentObj({}); return }
	},[uISDlglookupconsentshow]);
	React.useEffect(()=>{
		if((uDatamainObj.nama_tindakan||"").trim() !== ""
			|| (parseInt(uDatamainObj.pasien_obj||{}).umur||0) !== (parseInt(uDatadefaultObj.pasien_obj||{}).umur||0)
			|| (parseInt(uDatamainObj.kuasa_id)||0) !== (parseInt(uDatadefaultObj.kuasa_id)||0)
			|| ((uDatamainObj.dokter_obj||{}).url_tandatangan||"").trim() !== ""
			|| ((uDatamainObj.kuasa_obj||{}).url_tandatangan||"").trim() !== ""
			|| ((uDatamainObj.saksiklinik_obj||{}).url_tandatangan||"").trim() !== ""
			|| ((uDatamainObj.saksikeluarga_obj||{}).url_tandatangan||"").trim() !== ""
		) {
			setFieldupdated(true);
			return;
		} 

		//--CHECK_ARR_STATUS_INFORMASI_CHANGE--/
		const vFiltercheckArr = (uDatamainObj.variabelarr||[]).filter(vItems=>(vItems.status_informasi||"TIDAK")==="YA");
		if(vFiltercheckArr.length > 0) {
			setFieldupdated(true);
			return;
		}
		//--END CHECK_ARR_STATUS_INFORMASI_CHANGE--/

		//--CHECK_ARR_ISI_INFORMASI_CHANGE--/
		const vFilterinfoArr = (uDatamainObj.variabelarr||[]).filter(vItems=>(vItems.content||"").trim()!=="");
		if(vFilterinfoArr.length > 0) {
			setFieldupdated(true);
			return;
		}
		//--END CHECK_ARR_ISI_INFORMASI_CHANGE--/

		setFieldupdated(false);
	},[uDatamainObj.nama_tindakan,
	(uDatamainObj.pasien_obj||{}).umur,
	uDatamainObj.kuasa_id,
	(uDatamainObj.dokter_obj||{}).url_tandatangan,
	(uDatamainObj.kuasa_obj||{}).url_tandatangan,
	(uDatamainObj.saksiklinik_obj||{}).url_tandatangan,
	(uDatamainObj.saksikeluarga_obj||{}).url_tandatangan,
	(uDatamainObj.variabelarr||[]),
	]);
	React.useEffect(() => { window.scrollTo({top: 0}); },[activeKey]);
	//---END EFFECT--/

	//console.log("(Consentform2) uDokterID ",uDokterID);
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0" onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto text-normal">
				<b>Form Consent</b>
			</CHeaderBrand>

			<CHeaderNav>
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>

		<CContainer fluid className="bg-white p-1 px-3" style={{minHeight:0}}>
			{contentHeadersub()}
		</CContainer>
		
		{(!uHtml500msg) && (
		<>
			<div className="w-100 mb-2 classborderbottom"/>
		
			<div className="w-100 px-2">
				<CNav className="justify-content-md-center align-items-center border-bottom-0" variant="tabs">
					<CNavItem>
						<CNavLink active={activeKey === 1} className="classcursorpointer" onClick={() => setActiveKey(1)}>
						<small className="d-none d-md-block">Data Consent</small>
						<b className="d-md-none">1</b>
						</CNavLink>
					</CNavItem>
					<CNavItem>
						<CNavLink active={activeKey === 2} className="classcursorpointer" onClick={() => setActiveKey(2)}>
						<small className="d-none d-md-block">Data Pasien</small>
						<b className="d-md-none">2</b>
						</CNavLink>
					</CNavItem>
					<CNavItem>
						<CNavLink active={activeKey === 3} className="classcursorpointer" onClick={() => setActiveKey(3)}>
						<small className="d-none d-md-block">Penerima Informasi</small>
						<b className="d-md-none">3</b>
						</CNavLink>
					</CNavItem>

					<CNavItem>
						<CNavLink active={activeKey === 4} className="classcursorpointer" onClick={() => setActiveKey(4)}>
						<small className="d-none d-md-block">Isi Consent</small>
						<b className="d-md-none">4</b>
						</CNavLink>
					</CNavItem>

					<CNavItem>
						<CNavLink active={activeKey === 5} className="classcursorpointer" onClick={() => setActiveKey(5)}>
						<small className="d-none d-md-block">Tanda Tangan</small>
						<b className="d-md-none">5</b>
						</CNavLink>
					</CNavItem>

					<div className="px-2">
						<CButton size="sm" onClick={()=>hdlKlikPreview()} color="dark" id="btnPreview">
						<CIcon icon="cilNotes" className="" height={15}/>
						<small className="ms-1 d-none d-md-inline">Preview</small>
						<small className="ms-1 d-none d-lg-inline">Draft</small>
						</CButton>
					</div>
				</CNav>
			</div>
		</>
		)}
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-3">
		<CContainer xxl className="px-0">
			{(uHtml500msg) ? (
			<CCard className="classbgcard mb-2">
			<CCardHeader>Error Page 500</CCardHeader>
			<CCardBody>
				<div className="m-lg-3">{UFunc.renderHTML(uHtml500msg)}</div>
			</CCardBody>
			</CCard>
			) : (
			<CForm>
				<div className="d-none">{JSON.stringify(uSystemconfigObj)}</div>
				<CTabContent>
					<CTabPane role="tabpanel" className="" visible={activeKey === 1}>
					{contentConsentdata()}
					</CTabPane>

					<CTabPane role="tabpanel" className="" visible={activeKey === 2}>
					{contentPasien()}
					</CTabPane>

					<CTabPane role="tabpanel" className="" visible={activeKey === 3}>
					{contentKuasa()}
					</CTabPane>

					<CTabPane role="tabpanel" className="" visible={activeKey === 4}>
					{contentParagraf()}
					</CTabPane>

					<CTabPane role="tabpanel" className="" visible={activeKey === 5}>
					{contentSignature()}
					</CTabPane>
				</CTabContent>
			</CForm>
			)}
		</CContainer>
		</div>

		<CFooter position="sticky" className="px-3 text-black-50 justify-content-center" 
			style={{backgroundColor:"#AEAEAE99",borderTop:"1px dashed #f0f0f0"}}>
		<MyButton
			onClick={()=>hdlKlikSimpanmain()}
			disabled={!uISFieldupdated}
			id="btnSimpanmain">
			{uBahasaObj.word_simpan||"Simpan"}
			
			{(!isMobile) && (
				<span className="me-1">[F9]</span>
			)}
		</MyButton>
		</CFooter>
		</div>

		<MyDialogform
			options={{centered:true,size:"lg"}}
			onSimpan={hdlKlikDlgformsimpan}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<MyDialogformFs
			options={{centered:true,size:"lg"}}
			onSimpan={hdlKlikDlgformsimpan}
			dialogHeader={uDlgformObj.dlg_header}
			show={uISDlgformFsshow} 
			toggle={()=>setDlgformFsshow(false)}
			renderContent={contentDlgform()}/>

		<MyDialoglookupconsent
			dialogHeader={uDlglookupconsentObj.dlg_header}
			show={uISDlglookupconsentshow} 
			toggle={()=>setDlglookupconsentshow(false)}
			urlTarget={uDlglookupconsentObj.dlg_urltarget||""}
			onKlikPilihItem={hdlKlikDlglookupconsentpilih}
			{...props}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		<MySessionextender active={true} {...props}/>
		</>
	)//>
}	

export default Consentform2